import { render } from "./share-planner-actions.vue?vue&type=template&id=6b2f4604&ts=true"
import script from "./share-planner-actions.vue?vue&type=script&lang=ts"
export * from "./share-planner-actions.vue?vue&type=script&lang=ts"

import "./share-planner-actions.vue?vue&type=style&index=0&id=6b2f4604&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__